import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, timeout } from 'rxjs'; // Import lastValueFrom
import { Constants } from 'app/utility/constants';
import { CacheService } from './cache.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService 
{
    constructor
        (
            protected httpClient: HttpClient,
            protected cache: CacheService
        )
    {
    }

    protected get BaseUrl(): string
    {
        return Constants.ApiUrl;
    }

    private formatApiUrl(endpoint: string)
    {
        //strips trailing double slashes
        return `${Constants.ApiUrl.replace(/\/+$/, '')}/${endpoint.replace(/^\/+/, '')}`;
    }


    public get<T>(
        endpoint: string,
        params?: HttpParams,
        requestTimeout = Constants.ApiDefaultTimeout
    ): Observable<T>
    {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });
        const url = this.formatApiUrl(endpoint);

        return this.httpClient
            .get<T>(url, {
                headers,
                params,
                responseType: 'json'
            })
            .pipe(timeout(requestTimeout));
    }

    public post<T>(
        endpoint: string,
        body: any,
        params?: HttpParams,
        requestTimeout: number = Constants.ApiDefaultTimeout
    ): Observable<T>
    {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        const url = this.formatApiUrl(endpoint);

        return this.httpClient
            .post<T>(url, body, {
                headers,
                params,
                responseType: 'json'
            })
            .pipe(timeout(requestTimeout));
    }

    protected put<T>(
        endpoint: string,
        body: any,
        params?: HttpParams,
        requestTimeout = Constants.ApiDefaultTimeout
    ): Observable<T>
    {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        const url = this.formatApiUrl(endpoint);

        return this.httpClient
            .put<T>(url, body, {
                headers,
                params,
                responseType: 'json'
            })
            .pipe(timeout(requestTimeout));
    }

    public patch<T>(
        endpoint: string,
        body?: any,
        params?: HttpParams,
        requestTimeout: number = Constants.ApiDefaultTimeout
    ): Observable<T>
    {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        });

        const url = this.formatApiUrl(endpoint);

        return this.httpClient
            .patch<T>(url, body, {
                headers,
                params,
                responseType: 'json'
            })
            .pipe(timeout(requestTimeout));
    }
}